






































































import { Component, Vue } from 'vue-property-decorator';
import EmployeeNewButton from './EmployeeNewButton.vue';
import EmployeeEditButton from './EmployeeEditButton.vue';
import PermissionService from '@/utils/permission-service';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_employeeList } from '@/queries/__generated__/employeeList';
import { GQL_AltinnEmploymentTypeEnum } from '@/queries/global';
import dayjs from '@/utils/dayjs';
import gql from 'graphql-tag';

const EMPLOYEE_LIST = gql`
  query employeeList {
    currentUnit {
      id
      employees {
        id
        firstName
        lastName
        birthDate
        user {
          id
          login
          cellphone
        }
        workRelations {
          id
          startDate
          endDate
          pensionEndDate
          employmentType
          subUnit {
            id
            name
          }
        }
      }
    }
  }
`;

type Row = {
  id: string;
  firstName: string;
  lastName: string;
  cellphone: string | null;
  login: string;
  birthDate: string;
  employmentType: string | null;
  subUnitName: string | null;
  workRelationStartDate: string | null;
  workRelationEndDate: string | null;
};

@Component({
  components: {
    EmployeeNewButton,
    EmployeeEditButton,
  },
})
export default class EmployeeList extends Vue {
  private EMPLOYEE_LIST = EMPLOYEE_LIST;
  private PermissionService = PermissionService;
  private employmentTypes = Object.keys(GQL_AltinnEmploymentTypeEnum);

  @SmartQuery<EmployeeList, GQL_employeeList>({
    query: EMPLOYEE_LIST,
    fetchPolicy: "no-cache",
    update: data => {
      const arr: Row[] = [];

      data.currentUnit.employees.forEach(employee => {
        if(employee.workRelations.length == 0) {
          arr.push({
              id: employee.id,
              firstName: employee.firstName,
              lastName: employee.lastName,
              cellphone: employee.user.cellphone,
              login: employee.user.login,
              birthDate: employee.birthDate,
              employmentType: ``,
              subUnitName: ``,
              workRelationStartDate: ``,
              workRelationEndDate: ``,
            });
        } else {
          return employee.workRelations.forEach(workRelation => {
            arr.push({
              id: employee.id,
              firstName: employee.firstName,
              lastName: employee.lastName,
              cellphone: employee.user.cellphone,
              login: employee.user.login,
              birthDate: employee.birthDate,
              employmentType: workRelation.employmentType,
              subUnitName: workRelation.subUnit.name,
              workRelationStartDate: workRelation.startDate,
              workRelationEndDate: workRelation.endDate || workRelation.pensionEndDate,
            });
          });
        }
      });

      return arr;
    },
  }) public employees!: Row[];

  private get editable(): boolean {
    return PermissionService.check('canEditEmployees');
  }

  private get employmentTypeSelectOptions(): Record<string, string> {
    return this.employmentTypes.reduce((obj, type) => {
      obj[type] = this.$t(`Altinn.EmploymentTypes.${type}`) as string;
      return obj;
    }, {} as Record<string, string>);
  }

  private isActiveWorkRelation(item: Row, date: string | null): boolean {
    const startDate = item.workRelationStartDate && dayjs.strict(item.workRelationStartDate);
    const endDate = item.workRelationEndDate && dayjs.strict(item.workRelationEndDate);

    if (date && !dayjs.strict(date).isValid()) {
      date = dayjs.strict(date).format('YYYY-MM-DD');
    }

    if (date === null) return true;
    if (!startDate && !endDate) return true;
    if (startDate && endDate) return dayjs.strict(date).isBetween(startDate, endDate, 'date', '[]');
    if (startDate && !endDate) return dayjs.strict(date).isSameOrAfter(startDate, 'date');
    if (!startDate && endDate) return dayjs.strict(date).isSameOrBefore(endDate, 'date');

    return false;
  }

  private get todaysDate() {
    return dayjs().format('YYYY-MM-DD');
  }
}
